// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'



import App from './App'
import router from './router'

import store from "./store";

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'materialize-css/dist/css/materialize.min.css'

import VueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTable)



import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)
import VueClipboards from 'vue-clipboards'
Vue.use(VueClipboards)


import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js